import React, { createContext, useState, useEffect } from 'react';
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import enTranslation from '../locales/en.json';
import arTranslation from '../locales/ar.json';

// Initialize i18next
i18n
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: enTranslation },
      ar: { translation: arTranslation }
    },
    lng: 'en', // Default language is now English
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false
    }
  });

export const LanguageContext = createContext();

export const LanguageProvider = ({ children }) => {
  // Get language from localStorage or use 'en' as default
  const [language, setLanguage] = useState(() => {
    const savedLanguage = localStorage.getItem('language');
    return savedLanguage || 'en';
  });

  const changeLanguage = (lang) => {
    setLanguage(lang);
    // Save to localStorage
    localStorage.setItem('language', lang);
    i18n.changeLanguage(lang);
    document.documentElement.lang = lang;
    document.documentElement.dir = lang === 'ar' ? 'rtl' : 'ltr';
    // Refresh the page to ensure all components render with the new language
    window.location.reload();
  };

  useEffect(() => {
    // Set initial language from localStorage if available
    const savedLanguage = localStorage.getItem('language') || 'en';
    
    // Initialize language settings
    i18n.changeLanguage(savedLanguage);
    document.documentElement.lang = savedLanguage;
    document.documentElement.dir = savedLanguage === 'ar' ? 'rtl' : 'ltr';
    localStorage.setItem('language', savedLanguage);
    
    // Ensure state is in sync with localStorage
    setLanguage(savedLanguage);
  }, []);

  return (
    <LanguageContext.Provider value={{ language, changeLanguage }}>
      {children}
    </LanguageContext.Provider>
  );
}; 